module.exports = __webpack_public_path__ + "img/AMBSlot_lobby_tab_pic2.bc917bda.png";